// Validation utility functions for driver details

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateName = (name) => {
  const nameRegex = /^[a-zA-Z\s'-]{2,50}$/;
  return nameRegex.test(name.trim());
};

// validationUtils.js

export const validatePhone = (phone) => {
  if (!phone) return false;
  const e164 = toE164(phone);
  // 1. Check length (E.164 is 10-15 digits usually)
  // 2. Ensure it doesn't start with +0 (often used for fake/invalid numbers)
  const isValidE164 = /^\+[1-9]\d{10,15}$/.test(e164);
  return isValidE164;
};

export const toE164 = (raw) => {
  if (!raw) return "";
  const digits = String(raw).replace(/\D/g, "");
  return digits ? `+${digits}` : "";
};

export const validateField = (field, value) => {
  let error = "";

  switch (field) {
    case "firstName":
      if (!value.trim()) {
        error = "First name is required";
      } else if (!validateName(value.trim())) {
        error =
          "First name must be 2-50 characters and contain only letters, spaces, hyphens, and apostrophes";
      }
      break;
    case "lastName":
      if (!value.trim()) {
        error = "Last name is required";
      } else if (!validateName(value.trim())) {
        error =
          "Last name must be 2-50 characters and contain only letters, spaces, hyphens, and apostrophes";
      }
      break;
    case "email":
      if (!value.trim()) {
        error = "Email is required";
      } else if (!validateEmail(value.trim())) {
        error = "Please enter a valid email address";
      }
      break;
    case "phone":
      if (!value) {
        error = "Phone number is required";
      } else if (!validatePhone(value)) {
        error = "Please enter a valid phone number";
      }
      break;
    case "residency":
      if (!value) {
        error = "Country of residency is required";
      }
      break;
    case "dob":
      {
        if (!value) return "Please enter your date of birth.";

        const today = new Date();
        const dob = new Date(value);

        if (dob > today) {
          return "Date of birth cannot be in the future.";
        }

        const age = today.getFullYear() - dob.getFullYear();
        const m = today.getMonth() - dob.getMonth();

        const adjustedAge =
          m < 0 || (m === 0 && today.getDate() < dob.getDate()) ? age - 1 : age;

        if (adjustedAge < 21) {
          return "Driver must be atleast 21 years old";
        }

        return "";
      }
      break;
    default:
      break;
  }

  return error;
};

// Validate all driver details at once
export const validateDriverDetails = (driverDetails, acceptTerms) => {
  const errors = {
    firstName: validateField("firstName", driverDetails.firstName),
    lastName: validateField("lastName", driverDetails.lastName),
    email: validateField("email", driverDetails.email),
    phone: validateField("phone", driverDetails.phone),
    dob: validateField("dob", driverDetails.dob),
    residency: validateField("residency", driverDetails.residency),
    acceptTerms: !acceptTerms ? "You must accept the terms and conditions" : "",
  };

  return {
    errors,
    isValid: !Object.values(errors).some((error) => error !== ""),
  };
};
